/* ElapsedRenderer.js */

"use strict";

const _ = require("lodash");
const moment = require("moment");
require("moment-duration-format");

class ElapsedRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("elapsed-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }
    _registerListeners() {
        this._model.on("Elapsed", (this._onElapsed = this._onElapsed.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeAllListeners("Elapsed");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setElapsed(this._model.getValue());
            resolve();
        });
        return prom;
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onElapsed(newVal) {
        this._setElapsed(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _setElapsed(newVal) {
        if (!_.isUndefined(newVal)) {
            let elapsed = moment.duration(newVal, "milliseconds").format("hh:mm:ss", { trim: false });
            this._rootElem.innerHTML = elapsed;
        } else {
            this._rootElem.innerHTML = "";
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = ElapsedRenderer;
